module.exports = __webpack_public_path__ + "static/media/statement.0491cdce.svg";